/* eslint-disable no-useless-escape */
import { Injectable } from '@angular/core'
import {
  AbstractControl,
  FormControl,
  ValidationErrors,
  ValidatorFn
} from '@angular/forms'

@Injectable({
  providedIn: 'root'
})
export class KcValidationService {
  checkPasswords: ValidatorFn = (
    group: AbstractControl
  ): ValidationErrors | null => {
    const pass = group.get('password')
    const passConfirm = group.get('passwordConfirm')

    if (pass?.value !== passConfirm?.value) {
      passConfirm?.setErrors({ notsame: true })
    } else {
      passConfirm?.setErrors(null)
    }

    return null
  }

  public password = (control: FormControl): object => {
    if (control == null) {
      return {}
    }

    const value = control.value as string

    // one uppercase
    if (value?.match('[A-Z]') == null) {
      return { uppercase: true }
    }

    // one lowercase
    if (value?.match('[a-z]') == null) {
      return { lowercase: true }
    }

    // one numeric
    if (value?.match('[0-9]') == null) {
      return { numeric: true }
    }

    // length
    if (value?.length < 8) {
      return { length: true }
    }

    return {}
  }

  public germanAlphaCharactersOnly(control: FormControl): object {
    const value = control.value as string
    if (value.match('^[a-zA-ZÄäÜüÖöß\\s.-]*$') == null) {
      return { nonGermanAlphaCharacters: true }
    }

    return {}
  }

  public germanCharactersOnly(control: FormControl): object {
    const value = control.value as string
    if (value.match('^[a-zA-Z0-9ÄäÜüÖöß\\s.\\-/]*$') == null) {
      return { nonGermanCharacters: true }
    }

    return {}
  }

  public onlyNumbers(control: FormControl): object {
    const value = control.value as string
    if (value.toString().match(/^[0-9]+(\.?[0-9]+)?$/) == null)
      return { invalidNumber: true }

    return {}
  }

  public noEmptySpace(control: FormControl): object {
    const value = control.value as string
    if (value.includes(' ')) {
      return { noEmptySpace: true }
    }

    return {}
  }
}
